import React, { memo } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Image,
  Flex
} from '@chakra-ui/react'

function ImageZoomModalComponent({ isOpen, onClose, imageUrl, imageName = 'Arte' }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent maxW={{ base: "90%", md: "80%" }} maxH="90vh">
        <ModalHeader>{imageName}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex justifyContent="center" alignItems="center" p={2}>
            <Image 
              src={imageUrl} 
              alt={imageName} 
              maxH="70vh" 
              objectFit="contain" 
              borderRadius="md"
            />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export const ImageZoomModal = memo(ImageZoomModalComponent)
